import { RoomData } from '../data/room/Room';
import { IPoint2d } from '../math/IPoint2d';
import { EEntityType } from '../types';
import { IRect, RoomTextInfo, TextInfoModel } from './2d/textInfo';
import BaseEntity from './BaseEntity';

interface IRoomTextInfoEntityParams {
  data: RoomData;
  name: string;
  visible: boolean;
  withRegion: boolean;
}

export class RoomTextInfoEntity extends BaseEntity<EEntityType.TextInfo> {
  private _data: RoomData;
  private _label: RoomTextInfo;
  protected override _model2d: TextInfoModel;

  constructor(params: IRoomTextInfoEntityParams) {
    super({ type: EEntityType.TextInfo, id: params.data.id });
    this._data = params.data;
    this._label = new RoomTextInfo(params);
    this._model2d = new TextInfoModel({
      nameEl: this._label.nameEl,
      areaEl: this._label.areaEl,
      intersectable: true,
      entityId: this.id
    });
  }

  public getData() {
    return this._data;
  }

  public setVisible(visible: boolean) {
    this._model2d.setVisible(visible);
    this._label.setVisible(visible);
  }

  public getVisible() {
    return this._model2d.getVisible();
  }

  public override update(params: IRoomTextInfoEntityParams) {
    this._data = params.data;
    this._label.update(params);
    this._model2d.update();
  }

  public updateInfoEnable(enable: boolean) {
    this._label.updateInfoEnable(enable);
  }

  public resetFocus() {
    this._label.resetFocus();
  }

  public setSelected(selected: boolean) {
    this._selected = selected;
    this._label.setSelected(selected);
  }

  public setHover(hover: boolean) {
    this._label.setHover(hover);
  }

  public updateScale() {
    this._model2d.update();
  }

  public updatePosition() {
    this._label.updatePosition();
  }

  /** 更新位置，并避让给定的分区标签矩形（屏幕坐标） */
  public updatePositionAvoiding(regionRects: IRect[]) {
    this._label.updatePositionAvoiding(regionRects);
  }

  public setPositionOffset(offset?: IPoint2d) {
    return this._label.setPositionOffset(offset);
  }

  public getLabelRect() {
    return this._label.getBoundingClientRect();
  }

  override dispose(): void {
    super.dispose();
    this._label.dispose();
  }
}
